<template>
  <div>
    <div class="kqf-card">
      <el-form :inline="true" size="mini">
        <el-form-item label="反馈类型" class="ml20">
          <el-select v-model="search.value" clearable placeholder="请选择">
            <el-option v-for="item in options" :key="item.feedback_type_id" :label="item.name" :value="item.feedback_type_id"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="手机号：" class="ml20">
          <el-input v-model="search.mobile"></el-input>
        </el-form-item>
        <el-form-item label="处理人：" class="ml20">
          <el-input v-model="search.admin_username"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getList(1)">查询</el-button>
          <el-button @click="refresh">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="kqf-card" v-loading="loading" style="min-width: 1100px">
      <el-table border :data="datas.list" height="calc(100vh - 280px)">
        <el-table-column label="用户信息" width="250">
          <template slot-scope="scope">
            <div class="flex">
              <el-avatar :size="40" :src="scope.row.face"></el-avatar>
              <div style="margin-left: 10px">
                <p class="text-over">{{ scope.row.nickname }}</p>
                <el-link v-clipboard:success="copySuccess" v-clipboard:copy="scope.row.mobile" type="primary" :underline="false"
                  >{{ scope.row.mobile }}
                </el-link>
                <p class="text-over" v-if="scope.row.is_cancel_account == 1"><el-tag size="mini">账户已注销</el-tag></p>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="反馈类型" prop="feedback_type_name" width="100"></el-table-column>
        <el-table-column label="问题描述" prop="describe" align="center"></el-table-column>
        <el-table-column label="图片" align="center">
          <template slot-scope="scope">
            <div style="display: flex; flex-wrap: wrap; position: relative">
              <div v-for="(item, i) in scope.row.image" :key="i" style="position: relative">
                <template v-if="/(.*)\.(mp4|rmvb|avi|ts)$/.test(item)">
                  <img
                    style="width: 50px; height: 50px; margin-right: 10px"
                    :src="item + '?x-oss-process=video/snapshot,t_3000,f_jpg,m_fast,ar_auto'"
                    @click="handlerVideo(item)"
                  />
                  <img src="@/assets/images/order/play.png" alt="" class="videoPlay" @click="handlerVideo(item)" />
                </template>
                <el-image
                  class="img"
                  style="width: 50px; height: 50px; margin-right: 10px"
                  :src="item"
                  :preview-src-list="scope.row.image.filter(i => !/(.*)\.(mp4|rmvb|avi|ts)$/.test(i))"
                  v-else
                >
                </el-image>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="处理">
          <template slot-scope="scope">
            <p>处理人：{{ scope.row.admin_username }}</p>
            <p>处理结果：{{ scope.row.processing_result }}</p>
          </template>
        </el-table-column>
        <el-table-column label="时间" width="250">
          <template slot-scope="scope">
            <p>创建时间：{{ scope.row.create_time }}</p>
            <p>处理时间：{{ scope.row.processing_time }}</p>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="250">
          <template slot-scope="scope">
            <el-button size="mini" @click="editinfo(scope.row)" >处理</el-button>
            <el-button size="mini" @click="seeinfo(scope.row)" type="primary">查看</el-button>
            <!-- <el-button size="mini" @click="detailsJump(scope.row)">查看订单</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <div class="flex space mt10">
        <div>
          <el-pagination
            @current-change="getList"
            background
            :page-size="datas.limit"
            layout="total, prev, pager, next"
            :total="datas.count"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <!--编辑处理结果-->
    <el-dialog title="设置处理结果" :visible.sync="editdialog" width="500px">
      <el-form label-width="130px" size="small" v-loading="editloading">
        <el-form-item label="处理结果：" required>
          <el-input type="textarea" v-model="editdata.processing_result"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="edit()">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!--查看详情-->
    <el-dialog title="查看详情" :visible.sync="seedialog" width="800px">
      <p style="padding: 10px 0px; margin-top: -25px">处理结果信息</p>
      <el-descriptions class="margin-top" :column="2" border>
        <el-descriptions-item>
          <template slot="label"> 处理人 </template>
          {{ seedata.admin_username }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"> 处理时间 </template>
          {{ seedata.processing_time }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"> 处理结果 </template>
          {{ seedata.processing_result }}
        </el-descriptions-item>
      </el-descriptions>

      <p style="padding: 10px 0px">用户评价信息</p>
      <el-descriptions class="margin-top" :column="2" border>
        <el-descriptions-item>
          <template slot="label"> 服务打分 </template>
          <el-rate v-model="seedata.serve_point" disabled show-score text-color="#ff9900"> </el-rate>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"> 平台打分 </template>
          <el-rate v-model="seedata.platform_point" disabled show-score text-color="#ff9900"> </el-rate>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"> 服务评价 </template>
          {{ seedata.evaluate }}
        </el-descriptions-item>
      </el-descriptions>
    </el-dialog>
    <VideoPlay :visible.sync="videoShow" :videoSrc="videoSrc" />
  </div>
</template>

<script>
import { UserfeedbackList, userFeedbackType, SetProcessingResult } from '@/request/api/user/user'
import VideoPlay from '@/components/videoPlay'
export default {
  name: 'UserFeedBack',
  components: {
    VideoPlay
  },
  data() {
    return {
      search: this.getSearch(),
      datas: [],
      loading: false,
      options: [],
      editloading: false,
      editdialog: false,
      editdata: {
        processing_result: '',
        feedback_id: 0
      },
      seedialog: false,
      seedata: {
        admin_username: '',
        processing_time: '',
        processing_result: '',
        evaluate: '',
        platform_point: 0,
        serve_point: 0
      },
      videoSrc: '',
      videoShow: false
    }
  },

  created() {
    this.getList()
    this.getType()
  },
  methods: {
    //详情跳转
    detailsJump(row) {
      let pathInfo = this.$router.resolve({
        path: '/user/detail',
        query: {
          uid: row.uid,
          activeName: 'orderRecord'
        }
      })
      window.open(pathInfo.href, '_blank')
    },
    getSearch() {
      return {
        mobile: '',
        type: 0,
        value: '',
        admin_username: ''
      }
    },
    refresh() {
      this.search = this.getSearch()
      this.getList(1)
    },
    copySuccess() {
      this.$message.success('复制成功')
    },
    getList(page) {
      this.search.page = page
      this.loading = true
      UserfeedbackList({
        admin_username: this.search.admin_username,
        mobile: this.search.mobile,
        type: this.search.type,
        feedback_type_id: this.search.value ? this.search.value : -1,
        page: page
      })
        .then(res => {
          this.datas = res
          this.sumMoney = res.allmoney
          //赋值
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    getType() {
      userFeedbackType().then(res => {
        this.options = res.type
      })
    },
    //编辑信息填入
    editinfo(row) {
      this.editdialog = true
      this.editdata = Object.assign({}, row)
    },
    //查看详情
    seeinfo(row) {
      this.seedialog = true
      this.seedata = Object.assign({}, row)
    },
    //编辑
    edit() {
      this.editloading = true
      SetProcessingResult({
        ...this.editdata
      })
        .then(() => {
          this.editdialog = false
          this.$message.success('操作成功')
          this.editloading = false
          this.getList(1)
          this.editloading = false
        })
        .catch(() => {
          this.editloading = false
        })
    },
    handlerVideo(item) {
      this.videoSrc = item
      this.videoShow = true
    }
  }
}
</script>

<style scoped>
.videoPlay {
  width: 26px;
  height: 26px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>
